<template>
  <div class="block-flat">
    <div class="header">
      <h3>Pièces jointes à la demande</h3>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
      <b-form v-if="request" @submit.prevent="handleSubmit(send())">
        <div class="block-content">
          <div class="form-group">
            <!--                <div class="section">-->
            <!--                    <h2>Nature et date des Travaux</h2>-->
            <b-form-group>
              <legend>1. Générales</legend>
              <div
                v-for="document in missingDocuments"
                :key="document.typeDocument.id"
              >
                <b-row
                  v-if="
                    !!document.typeDocument.isMandatory &&
                    ((request.type.length > 1 &&
                      document.typeDocument.cerfa == request.type[0]) ||
                      (request.type.length > 1 &&
                        document.typeDocument.cerfa == request.type[1]) ||
                      (request.type.length > 1 &&
                        document.typeDocument.cerfa ==
                          request.type.join(',')) ||
                      (request.type.length == 1 &&
                        document.typeDocument.cerfa.includes(request.type)))
                  "
                >
                  <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                    <label class="control-label">{{
                      document.typeDocument.name
                    }}</label>
                  </b-col>
                  <b-col xl="9" lg="8" md="8" sm="12" cols="12">
                    <b-form-file
                      browse-text="Déposer"
                      v-model="document.file"
                      placeholder="Choisissez un Fichier ou glissez le ici..."
                      drop-placeholder="Glissez un Fichier ici..."
                    ></b-form-file>
                    <!-- <div class="mt-3">
				  Fichier Sélectionné:
				  {{ document.file ? document.file.name : "" }}
				</div> -->
                    <!-- @click="sendDocuments()" -->
                  </b-col>
                </b-row>
              </div>
            </b-form-group>
            <b-form-group>
              <legend>2. Pièces Complémentaires</legend>
              <!-- cloture stationnement -->
              <div v-for="document in missingDocuments" :key="document.id">
                <b-row
                  v-if="
                    document.typeDocument.isMandatory == false &&
                    ((request.type.length > 1 &&
                      document.typeDocument.cerfa == request.type[0]) ||
                      (request.type.length > 1 &&
                        document.typeDocument.cerfa == request.type[1]) ||
                      (request.type.length > 1 &&
                        document.typeDocument.cerfa ==
                          request.type.join(',')) ||
                      (request.type.length == 1 &&
                        document.typeDocument.cerfa.includes(request.type))) &&
                    (document.typeDocument.nature == null ||
                      document.typeDocument.nature == '') &&
                    document.typeDocument.id != 17 &&
                    document.typeDocument.id != 20
                  "
                >
                  <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                    <label class="control-label">{{
                      document.typeDocument.name
                    }}</label>
                  </b-col>
                  <b-col xl="9" lg="8" md="8" sm="12" cols="12">
                    <b-form-file
                      browse-text="Déposer"
                      v-model="document.file"
                      placeholder="Choisissez un Fichier ou glissez le ici..."
                      drop-placeholder="Glissez un Fichier ici..."
                    ></b-form-file>
                  </b-col>
                </b-row>
                <div v-if="soustypes != null">
                  <div v-for="soustype in soustypes.split(',')" :key="soustype">
                    <b-row
                      v-if="
                        document.typeDocument.isMandatory == false &&
                        (document.typeDocument.cerfa == request.type[0] ||
                          document.typeDocument.cerfa == request.type[1] ||
                          document.typeDocument.cerfa ==
                            request.type.join(',')) &&
                        document.typeDocument.nature != null &&
                        document.typeDocument.nature
                          .split(',')
                          .includes(soustype)
                      "
                    >
                      <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                        <label class="control-label">{{
                          document.typeDocument.name
                        }}</label>
                      </b-col>
                      <b-col xl="9" lg="8" md="8" sm="12" cols="12">
                        <b-form-file
                          browse-text="Déposer"
                          v-model="document.file"
                          placeholder="Choisissez un Fichier ou glissez le ici..."
                          drop-placeholder="Glissez un Fichier ici..."
                        ></b-form-file>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="stepper-control">
          <b-button
            variant="white"
            @click="previous"
            class="btn marginRight-10 marginBottom-15"
          >
            <font-awesome-icon
              icon="caret-left"
              class="marginRight-5"
            ></font-awesome-icon>
            Précédent
          </b-button>
          <b-button type="submit" variant="primary" class="marginBottom-15">
            <span>Suivant</span>
            <font-awesome-icon
              icon="caret-right"
              class="marginLeft-5"
            ></font-awesome-icon>
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

export default {
  props: ["value"],
  name: "PiecesJointes",
  async mounted() {
    let rep = null;
    rep = await this.getMissingDocuments(this.request);
  },
  data: () => ({
    piece: {
      file: null,
      name: null,
      path: null,
      url: null,
      typeDocument: {
        name: null,
        cerfa: [],
        nature: [],
      },
    },
  }),
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023", "cerfa14024"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Document", ["missingDocuments"]),
    soustypes: function () {
      if (this.cerfa14023) {
        return this.cerfa14023.themes;
      } else {
        return null;
      }
    },
    request: {
      get() {
        return this.dossierSelected;
      },
      set(value) {
        this.$emit("setDossier", value);
      },
    },
    pieces: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
    ...Vuex.mapActions("Document", ["getMissingDocuments"]),
  },
};
</script>

<style scoped></style>
